export default __webpack_public_path__ + "static/media/tas-check-outline.54d2d959.svg";